import { getDataOrNil } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getDataOrNil'

export const getFixedSumAll = (...args: (number | undefined | null)[]): number => {
  const sum = args.reduce((acc: number, val) => acc + getDataOrNil(val), 0)
  return Number(sum.toFixed(2))
}
